import { useQuery } from '@tanstack/react-query';
import { getApiV1AnalogueModelsByIdArchelProportions } from '../../../../api/generated';
import { BBox, Proportions } from '../modelAreaCoordinates.utils';
import { queryKeys } from '../../../../hooks/queryKeys';

function dtoToProportions(
  list: Array<{ archelId?: number; proportion?: number }> | null | undefined,
): Proportions {
  const result: Proportions = {};
  list?.forEach((p) => {
    if (p.archelId !== undefined && p.proportion !== undefined) {
      result[p.archelId] = p.proportion;
    }
  });
  return result;
}

export const useArchelWholeModelProportions = (modelId: string | undefined) => {
  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeys.archelProportions(modelId as string, 'whole'),
    queryFn: async () => {
      const res = await getApiV1AnalogueModelsByIdArchelProportions({
        path: { id: modelId ?? '' },
      });
      return dtoToProportions(res.data?.data?.proportions);
    },
    enabled: !!modelId,
    staleTime: Infinity,
  });
};

export const useArchelBboxProportions = (
  modelId: string | undefined,
  bbox: BBox | null,
) => {
  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeys.archelProportions(modelId as string, bbox as BBox),
    queryFn: async () => {
      const id = modelId ?? '';
      const { x0, y0, x1, y1 } = bbox ?? { x0: 0, y0: 0, x1: 0, y1: 0 };
      const res = await getApiV1AnalogueModelsByIdArchelProportions({
        path: { id },
        query: { x0, y0, x1, y1 },
      });
      return dtoToProportions(res.data?.data?.proportions);
    },
    enabled: !!modelId && bbox !== null,
  });
};
